import { cn } from '@/lib/utils';

export const EDITOR_MEDIA_FRAME_CLASS = 'border border-border bg-muted/20';
export const EDITOR_MEDIA_SELECTED_CLASS = 'ring-2 ring-editor-primary/70';

export function getEditorMediaFrameClassName({
  isPageEditor,
  isEmpty,
  isSelected = false,
}: {
  isPageEditor: boolean;
  isEmpty: boolean;
  isSelected?: boolean;
}): string | undefined {
  if (!isPageEditor) {
    return undefined;
  }

  return (
    cn(isEmpty && EDITOR_MEDIA_FRAME_CLASS, isSelected && EDITOR_MEDIA_SELECTED_CLASS) || undefined
  );
}
